"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreespinsHistory = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var next_intl_1 = require("next-intl");
var currencies_1 = require("../currencies");
var useCache_1 = require("../useCache");
var CURRENT_CURRENCY = 'current_currency';
var CURRENT_LANG = 'current_lang';
var useFreespinsHistory = function () {
    var lang = (0, next_intl_1.useLocale)();
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.MY_FREESPINS_HISTORY,
        revalidateOnMount: true,
        payload: {
            currency: currentCurrency,
            lang: lang,
        },
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevLang = getDataFromCache(CURRENT_LANG);
        if (!prevCurrency ||
            prevCurrency !== currentCurrency ||
            !prevLang ||
            prevLang !== lang) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
        }
    }, [getDataFromCache, setDataToCache, currentCurrency, mutate, lang]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useFreespinsHistory = useFreespinsHistory;
